<template>
  <div>
    <ClientSearch v-if="type === 'clients'" :dbConfig="type" @search="(v) => $emit('search', v)" />
    <RouteSearch v-else-if="type === 'routes'" :dbConfig="type" @search="(v) => $emit('search', v)" />
    <ImageSearch v-else-if="type === 'images'" :dbConfig="type" @search="(v) => $emit('search', v)" />
    <ProgramPageSearch v-else-if="type === 'program_pages'" :dbConfig="type" @search="(v) => $emit('search', v)" />
    <MainSearch v-else :dbConfig="type" :mod="mod" @search="(v) => $emit('search', v)" />
  </div>
</template>

<script>
import ClientSearch from "./_ClientSearch";
import RouteSearch from "./_RouteSearch";
import ImageSearch from "./_ImageSearch";
import ProgramPageSearch from "./_ProgramPageSearch";
import MainSearch from "./_MainSearch";

export default {
  props: {
    type: String,
    mod: String,
  },
  components: {
    ClientSearch,
    RouteSearch,
    ImageSearch,
    ProgramPageSearch,
    MainSearch,
  },
  data() {
    return {};
  },
};
</script>

<style>
.s-field {
  flex: 0 0 50%;
}
</style>
